import PropTypes from "prop-types";

import { Chip, Stack } from "@mui/material";

// Tab label with a trailing record count, so the number of rows behind each tab
// is visible without opening it. Pass as a Tab's `label`:
//   <Tab label={<TabLabelWithCount label="Pesanan" count={rows.length} />} />
export const TabLabelWithCount = ({ label, count }) => (
  <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
    <span>{label}</span>
    <Chip
      label={count}
      size="small"
      sx={{
        height: 20,
        minWidth: 20,
        fontSize: "0.7rem",
        "& .MuiChip-label": { px: 0.75 },
      }}
    />
  </Stack>
);

TabLabelWithCount.propTypes = {
  label: PropTypes.node.isRequired,
  count: PropTypes.number,
};
